import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import css from './ISOModal.module.css';
import TypographyWrapper, { TypographyWeight } from '../TypographyWrapper/TypographyWrapper';
import { useDefaultShopStyles } from '../../hooks/useDefaultShopStyles';

const ISOHeader: FC<{ headerCopy: string }> = (props) => {
  const { headerCopy } = props;
  const { popoverBackgroundColor } = useDefaultShopStyles();

  return (
    <Box py={2} className={css.header} bgcolor={popoverBackgroundColor}>
      <TypographyWrapper
        variant="h2"
        weight={TypographyWeight.Bold}
        typographyOverrides={{ align: 'center' }}
      >
        {headerCopy}
      </TypographyWrapper>
    </Box>
  );
};

export default ISOHeader;
